import React, { useEffect, useState } from 'react';
import { useCartStore } from 'src/hooks/cart';
import { useAxiosIndicatorCheck } from 'src/store/hook/useAxiosIndicatorCheck';
import useReduxState from 'src/hooks/useReduxState';
import ProPositionWarning from './ProPositionWarning';
import System from 'src/helper/system';
import Constants from 'src/helper/Constants';
import { useOrderStore } from 'src/hooks/order';
import { __remove, __set } from "src/store/axios_indicator";

const CheckoutTotal = (props) => {
    const { shippingAddressType: { CountryCode: { US }, StateCode: { CA } }, currencyType: { USD }, taxExempt: { NONE } } = Constants
    const { isFrom } = props
    const [__check] = useAxiosIndicatorCheck();
    const [{ CART_DATA, CART_PRODUCTS, CART_SUB_TOTAL, CART_TAX_TARIFF, CART_COUNT, }, {
        fetch_cart_tax,
    }, { set_cart_tax }] = useCartStore()
    const [{ place_order_item_list }, { billing_currency_conversion }, { }] = useOrderStore();
    const { EXEMPT } = Constants.taxExempt
    const [taxExemptDetails, setTaxExemptDetails] = useReduxState({ taxExemptFile: '', taxExempt: NONE }, "setTaxExemptDetails");
    const [shippingAddressInfo] = useReduxState({}, 'setShippingAddressInfo')
    const [paymentMethodInfo] = useReduxState({}, 'setPaymentMethodInfo')
    const [prop65Part, setProp65Part] = useState(false);
    const [{ validate_order_from_server }] = useOrderStore();
    const [shippingMethodInfo,] = useReduxState({}, 'setShippingMethodInfo')
    const checkoutDataModel = {
        estimatedShipping: 0,
        estimatedTarrif: 0,
        estimatedTax: EXEMPT,
        itemsSubTotal: 0,
        orderTotal: 0,
        rateOfExchange: 0,
        billingCurrency: paymentMethodInfo?.billingCurrency || USD
    }
    const [checkoutData, setCheckoutData] = useReduxState(checkoutDataModel, 'setCheckoutData')
    const [monitorFunctionCall, setMonitorFunctionCall] = useState({ monitorJs: false, frameworkReady: false });

    useEffect(() => {
        async function containsProp65Yes() {
            if (CART_PRODUCTS && Object.values(CART_PRODUCTS)?.length > 0) {
                const isProp65 = Object.values(CART_PRODUCTS).find(f => f.Prop65Flag === true)
                if (isProp65) {
                    setProp65Part(true)
                } else {
                    setProp65Part(false);
                }
            }
        }
        containsProp65Yes()
    }, [CART_DATA])
    if (isFrom === "checkout") {
        useEffect(() => {
            if (!shippingAddressInfo?.id || !validate_order_from_server || (validate_order_from_server?.taxExempt && taxExemptDetails?.taxExempt === EXEMPT)) {
                set_cart_tax({
                    ...CART_TAX_TARIFF,
                    tax: EXEMPT,
                })
                return;
            }
            const params = {
                addressLineOne: shippingAddressInfo?.address?.addressLineOne || '',
                cityName: shippingAddressInfo?.address?.cityName || '',
                stateCode: shippingAddressInfo?.address?.stateCode || '',
                postalCode: shippingAddressInfo?.address?.postalCode || '',
                countryCode: shippingAddressInfo?.address?.countryCode || '',
                currency: checkoutData?.billingCurrency || paymentMethodInfo?.billingCurrency || USD,
                subTotal: CART_SUB_TOTAL || 0,
                shipToAddressId: shippingAddressInfo?.id,
                estimatedShipping: Number(shippingMethodInfo.value) || 0,
                taxExempt: taxExemptDetails?.taxExempt || NONE
            }
            async function fetchHere() {
                await fetch_cart_tax(params);
            }
            fetchHere();
        }, [CART_SUB_TOTAL, shippingAddressInfo?.id, shippingMethodInfo.value, taxExemptDetails?.taxExempt, validate_order_from_server?.taxExempt]);

        useEffect(() => {
            async function fetchHere() {
                __set('CART_TOTAL_SUMMARY_CALCULATION')
                const params = {
                    baseCurrency: USD,
                    billingCurrency: paymentMethodInfo?.billingCurrency,
                    orderTotal: CART_SUB_TOTAL + (Number(CART_TAX_TARIFF.tax) || 0) + (Number(CART_TAX_TARIFF.tariff) || 0) + (Number(shippingMethodInfo.value) || 0),
                    estimatedShipping: Number(shippingMethodInfo.value) || 0,
                    estimatedTarrif: Number(CART_TAX_TARIFF.tariff) || 0,
                    estimatedTax: Number(CART_TAX_TARIFF.tax) || 0,
                    itemsSubTotal: CART_SUB_TOTAL,
                }
                const res = await billing_currency_conversion(params);
                if (res) {
                    setCheckoutData({
                        estimatedShipping: res?.estimatedShipping,
                        estimatedTarrif: res?.estimatedTarriff,
                        estimatedTax: res?.estimatedTax,
                        itemsSubTotal: res?.itemsSubtotal,
                        billingCurrency: res?.billingCurrency,
                        orderTotal: Number(res?.orderTotal) || 0,
                        rateOfExchange: res?.exchangeRate
                    })
                    if (!monitorFunctionCall?.frameworkReady) {
                        System.monitorFrameWorkReady()
                        setMonitorFunctionCall({ ...monitorFunctionCall, frameworkReady: true })
                    }

                }
                __remove('CART_TOTAL_SUMMARY_CALCULATION')
            }
            if (checkoutData?.orderTotal !== 0 && paymentMethodInfo?.billingCurrency != USD && Object.keys(validate_order_from_server || {})?.length > 0) {
                fetchHere();
            } else {
                setCheckoutData({
                    estimatedShipping: Number(shippingMethodInfo.value) || 0,
                    billingCurrency: paymentMethodInfo?.billingCurrency,
                    estimatedTarrif: CART_TAX_TARIFF.tariff,
                    estimatedTax: CART_TAX_TARIFF.tax,
                    itemsSubTotal: CART_SUB_TOTAL,
                    orderTotal: CART_SUB_TOTAL + (Number(CART_TAX_TARIFF.tax) || 0) + (Number(CART_TAX_TARIFF.tariff) || 0) + (Number(shippingMethodInfo.value) || 0),
                    rateOfExchange: 0,
                });
            }
        }, [paymentMethodInfo?.billingCurrency, CART_TAX_TARIFF])

    } else if (isFrom === "SuccessCheckout") {
        useEffect(() => {
            setCheckoutData({ ...place_order_item_list?.orderEstimation, billingCurrency: place_order_item_list?.orderEstimation?.currencyType });
            setTaxExemptDetails({ ...taxExemptDetails, taxExempt: place_order_item_list?.orderEstimation?.taxExempt || NONE })
        }, [place_order_item_list])
    }

    useEffect(() => {
        if (!monitorFunctionCall?.monitorJs) {
            System.monitorJSDx()
            setMonitorFunctionCall({ ...monitorFunctionCall, monitorJs: true })
        }
    }, []);

    return (
        <>
            <div className="checkout-total">
                {__check(['CART_TAX_API_CALL', 'CART_TOTAL_SUMMARY_CALCULATION']).status ?
                    __check(['CART_TAX_API_CALL', 'CART_TOTAL_SUMMARY_CALCULATION']).render
                    :
                    <>
                        <div className='p-15'>
                            <div className="bs5 row mb-1">
                                <div className="col-12">
                                    <div className="bs5 row m-0">
                                        <div className="col-6 px-0">
                                            <span
                                                className="cart-item-count">({isFrom === "checkout" ? System.getCurrentCartCount() : (place_order_item_list?.items?.length || 0)}) </span>
                                            Items Subtotal:
                                        </div>
                                        <div className="col-6 text-end font_bold_currency ps-1 pe-0">
                                            <span className="font_bold_currency">
                                                {System.getFormatNumber({
                                                    amount: Number(checkoutData?.itemsSubTotal || 0) || 0,
                                                    maximumFractionDigits: 2,
                                                    isDisplaySymbol: false,
                                                    currency: checkoutData?.billingCurrency
                                                }) || 0}
                                            </span>
                                        </div>
                                    </div>
                                </div>

                            </div>

                            <div className="bs5 row mb-1 tariff">
                                <div className="col-6">Estimated Tariff:</div>
                                <div className="col-6 text-end">
                                    <b>{Number(checkoutData?.estimatedTarrif) === 0 ? "---" : System.getFormatNumber({
                                        amount: Number(checkoutData?.estimatedTarrif) || 0,
                                        isDisplaySymbol: false,
                                        currency: checkoutData?.billingCurrency,
                                        maximumFractionDigits:2
                                    }) || 0}</b>
                                </div>
                            </div>
                            {validate_order_from_server?.message?.countryTariff && <div className="bs5 row mt-2 mb-2">
                                <div className="col-8 ms-2"><i>– the estimated tariff recovery fee is an estimate and will be charged at the time of shipment.</i></div>
                                <div className="col-2 text-end"></div>
                            </div>}
                            <div className="bs5 row mb-1">
                                <div className="col-8"><span className='me-1'>Estimated Shipping:</span>
                                    {/* <img src={infoCircle} alt='Estimated Shipping' /> */}
                                </div>
                                <div className="col-4 text-end"><b>{System.getFormatNumber({
                                    amount: Number(checkoutData?.estimatedShipping) || 0,
                                    isDisplaySymbol: false,
                                    currency: checkoutData?.billingCurrency
                                }) || 0}</b></div>
                            </div>
                            <div className="bs5 row mb-1">
                                <div className="col-6">Estimated Tax:</div>
                                <div className="col-6 text-end est-tax">
                                    <b>{((validate_order_from_server?.taxExempt || isFrom === "SuccessCheckout") && taxExemptDetails?.taxExempt === EXEMPT) ? "EXEMPT" : System.getFormatNumber({
                                        amount: Number(checkoutData?.estimatedTax) || 0,
                                        isDisplaySymbol: false,
                                        currency: checkoutData?.billingCurrency
                                    }) || 0}</b>
                                </div>
                            </div>


                        </div>
                        <div className="bs5 row total-row m-0 ">
                            <div className="bs5 row m-0 font_bold_currency">
                                <div className="col-4 px-0">
                                    <span><b>Order Total:</b></span>
                                </div>
                                <div className="col-8 text-end est-tax ps-1 pe-0">
                                    <>
                                        <span
                                            className="subtotal-currency font-normal">{checkoutData?.billingCurrency} </span>
                                        <span
                                            className="font_bold_currency">{System.getFormatNumber({
                                                amount: Number(checkoutData?.orderTotal) || 0,
                                                maximumFractionDigits: 2,
                                                isDisplaySymbol: false,
                                                currency: checkoutData?.billingCurrency
                                            }) || 0}</span>
                                    </>
                                </div>
                            </div>
                        </div>
                    </>
                }
            </div>
            {((shippingAddressInfo?.address?.countryCode === US && shippingAddressInfo?.address?.stateCode === CA) || prop65Part) &&
                <ProPositionWarning />}
        </>
    );
}

export default CheckoutTotal;